module.exports = __webpack_public_path__ + "static/img/playIcon.6fba7fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/playIcon.png
// module id = 7oLk
// module chunks = 3